import React from "react";
import {Loader} from "../../components/Loader";
import {ListComponent} from "../../components/ListComponent";
import {SubScriptionInfoElement} from "./SubScriptionInfoElement";

export class SubscriptionInfo extends ListComponent {
    protected getRequestUrl(): RequestInfo | URL {
        return '/subscription/info';
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 's.subscription_id:a'}/>
                        {this.listOfSearchParams(params)}
                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['refresh']}
                                </button>
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['subscription-info']}: &nbsp;
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>
                <SubScriptionInfoElement items={this.state?.items} total={true}/>
            </>
        );
    }

}
